/* TRUFOLK® home: tabs, chips del newsletter, "Agregar el set" (cart drawer de Persuva), parallax y reveal. Sin dependencias. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var design = !!(window.Shopify && window.Shopify.designMode);
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var hasIO = 'IntersectionObserver' in window;
  if (!design && !reduce && hasIO) root.classList.add('tfh-js');

  function each(scope, sel, fn) { Array.prototype.forEach.call(scope.querySelectorAll(sel), fn); }

  var io = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }) : null;

  function initTabs(scope) {
    each(scope, '[data-tfh-tabs]', function (w) {
      if (w.hasAttribute('data-tfh-ready')) return;
      w.setAttribute('data-tfh-ready', '');
      var tabs = w.querySelectorAll('[data-tab]');
      var panels = w.querySelectorAll('[data-panel]');
      Array.prototype.forEach.call(tabs, function (t) {
        t.addEventListener('click', function () {
          Array.prototype.forEach.call(tabs, function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
          Array.prototype.forEach.call(panels, function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-panel') === t.getAttribute('data-tab'));
          });
        });
      });
    });
  }

  function initLeads(scope) {
    each(scope, '[data-tfh-lead]', function (f) {
      if (f.hasAttribute('data-tfh-ready')) return;
      f.setAttribute('data-tfh-ready', '');
      each(f, '.tf-chip', function (c) {
        c.addEventListener('click', function () {
          c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        });
      });
      f.addEventListener('submit', function () {
        var tags = f.querySelector('[data-tfh-tags]');
        if (!tags) return;
        var list = [tags.getAttribute('data-base') || ''];
        each(f, '.tf-chip[aria-pressed="true"]', function (c) { list.push(c.getAttribute('data-tag')); });
        tags.value = list.filter(Boolean).join(',');
      });
    });
  }

  function initReveal(scope) {
    if (!root.classList.contains('tfh-js') || !io) return;
    each(scope, '.tfh [data-stagger]', function (g) {
      Array.prototype.forEach.call(g.children, function (c, i) {
        c.style.setProperty('--d', i % 4);
        c.setAttribute('data-reveal', '');
      });
    });
    each(scope, '.tfh [data-reveal]:not(.in)', function (el) { io.observe(el); });
  }

  d.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-tfh-set]') : null;
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('aria-busy') === 'true') return;
    var items = (b.getAttribute('data-tfh-set') || '').split(',').filter(Boolean).map(function (id) {
      return { id: Number(id), quantity: 1 };
    });
    if (!items.length) return;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    b.setAttribute('aria-busy', 'true');
    fetch(base + 'cart/add.js?sections=cart-drawer,cart-icon-bubble', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); }).then(function (s) {
      if (!s || s.status) throw new Error((s && s.description) || 'cart');
      var drawer = d.querySelector('cart-drawer');
      if (drawer && s.sections && typeof drawer.renderContents === 'function') {
        drawer.renderContents({ id: s.items && s.items[0] && s.items[0].id, sections: s.sections });
      } else {
        window.location.href = base + 'cart';
      }
    }).catch(function () {
      window.location.href = base + 'cart';
    }).then(function () {
      b.removeAttribute('aria-busy');
    });
  });

  var pxEls = [], pxBound = false, ticking = false;
  function pxUpdate() {
    ticking = false;
    var vh = window.innerHeight || 1;
    pxEls.forEach(function (el) {
      var host = el.parentNode;
      if (!host) return;
      var r = host.getBoundingClientRect();
      if (r.bottom < -50 || r.top > vh + 50) return;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.transform = 'translate3d(0,' + (p * -10).toFixed(2) + '%,0)';
    });
  }
  function initParallax() {
    if (reduce) return;
    pxEls = Array.prototype.slice.call(d.querySelectorAll('.tfh [data-tfh-px]'));
    if (!pxEls.length) return;
    if (!pxBound) {
      pxBound = true;
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(pxUpdate); }
      }, { passive: true });
      window.addEventListener('resize', pxUpdate);
    }
    pxUpdate();
  }

  function init(scope) { initTabs(scope); initLeads(scope); initReveal(scope); }
  init(d);
  initParallax();
  d.addEventListener('shopify:section:load', function (e) { init(e.target); initParallax(); });
})();
